import {configureStore} from "@reduxjs/toolkit"
import authSlice from "./Slices/authSlice"
import formSlice from "./Slices/formSlice"
import generateSlice from "./Slices/generateSlice"

const store = configureStore({
    reducer: {
        auth: authSlice,
        form: formSlice,
        generate : generateSlice,
    },
});

export default store;
